import React from 'react';
import { SectionWrapper } from './Shared';
import { Check, X } from 'lucide-react';
export const AudienceSection = () => {
  const isFor = ['Hombres de 30 a 55 años que se sienten agotados sin razón aparente.', 'Padres que quieren recuperar la energía para estar presentes con su familia.', 'Profesionales con "niebla mental" que han perdido el enfoque en sus metas.', 'Hombres que han ganado grasa abdominal y han perdido su "chispa" vital.'];
  const notFor = ['Hombres que buscan una pastilla mágica que solucione todo en 24 horas.', 'Personas que no están dispuestas a soltar el celular 90 minutos antes de dormir.', 'Aquellos que prefieren quejarse de la edad antes que tomar acción real.'];
  return <SectionWrapper data-id="element-13">
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-14">
        {/* Para quién ES */}
        <div className="bg-dark-800 border border-green-500/20 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-15">
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/5 blur-[50px] rounded-full" data-id="element-16"></div>
          <h3 className="font-oswald text-2xl md:text-3xl font-bold text-white uppercase mb-8 flex items-center gap-3" data-id="element-17">
            <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-18">
              <Check className="w-6 h-6 text-green-500" data-id="element-19" />
            </div>
            Para quién es esto
          </h3>
          <ul className="space-y-6 relative z-10" data-id="element-20">
            {isFor.map((item, idx) => <li key={idx} className="flex gap-4 items-start" data-id="element-21">
                <Check className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-22" />
                <span className="text-zinc-300" data-id="element-23">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Para quién NO ES */}
        <div className="bg-dark-900 border border-red-500/20 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-24">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 blur-[50px] rounded-full" data-id="element-25"></div>
          <h3 className="font-oswald text-2xl md:text-3xl font-bold text-white uppercase mb-8 flex items-center gap-3" data-id="element-26">
            <div className="w-10 h-10 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-27">
              <X className="w-6 h-6 text-red-500" data-id="element-28" />
            </div>
            Para quién NO es
          </h3>
          <ul className="space-y-6 relative z-10" data-id="element-29">
            {notFor.map((item, idx) => <li key={idx} className="flex gap-4 items-start" data-id="element-30">
                <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-31" />
                <span className="text-zinc-400" data-id="element-32">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </SectionWrapper>;
};